import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgAdd = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 16 17"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M7 1.727a1 1 0 0 1 2 0v14a1 1 0 0 1-2 0z" />
    <path d="M1 9.727a1 1 0 1 1 0-2h14a1 1 0 1 1 0 2z" />
  </svg>
);
export default SvgAdd;
